import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { from, Observable, ReplaySubject } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { BASE_URL } from '../global/constants';
import { UserService } from './user.service';
import { StorageService } from './storage.service';
import { LookupItem, LookupResult, LookupValue } from '../../proxy/models/lookup';
import { TableName } from '../../proxy/models/table-name-enum';
import { EntityType } from '../../proxy/models/entity-type.enum';

@Injectable({
    providedIn: 'root',
})
export class AllLookupsService {
    private storageKey = 'salOBAllLookups';
    private isLookupsReadySubject$ = new ReplaySubject<boolean>(1);
    public isLookupsReady = this.isLookupsReadySubject$.asObservable();


    constructor(
        @Inject(BASE_URL) private baseUrlProvider: string,
        private storageService: StorageService,
        private userService: UserService,
        private http: HttpClient
    ) {}

    public getAllLookups(): Observable<LookupResult> {
        const user = this.userService.getUser();
        const data = {
            queryEntityId: EntityType?.lookup,
            queryArgs: {
                area: 'Registry'
            },
            usr: user,
        }

        return from(this.baseUrlProvider).pipe(
            switchMap(baseUrl =>
                this.http.post(baseUrl + 'ExecuteQuery', data) as Observable<LookupResult>
            )
        );
    }

    public setLookups(data: LookupItem[]): void {
        this.storageService.saveData(this.storageKey, JSON.stringify(data), sessionStorage);
    }

    public setIsLookupReady(): void {
        this.isLookupsReadySubject$.next(true);
    }

    public removeIsLookupReady(): void {
        this.isLookupsReadySubject$.next(false);
    }

    public getLookups(): LookupItem[] | null {
        const user = this.storageService.getData(this.storageKey, sessionStorage);
        return (user && JSON.parse(user)) || null;
    }

    public getLookupsByTableName(tableName: TableName) {
        return this.getLookups()?.find((el) => {
            return el.TableName === tableName;
        })?.LookupValue || [];
    }

    public getLookupByValue(table: TableName, value: string): LookupValue | undefined {
        return this.getLookups()?.find((item) => {
            return item?.TableName == table;
        })?.LookupValue.find((el) => {
            return el.LookupName === value;
        });
    }

    public getLookupById(table: TableName, id: string): LookupValue | undefined {
        return this.getLookups()?.find((item) => {
            return item?.TableName == table;
        })?.LookupValue.find((el) => {
            return el.LookupValueId === id;
        });
    }

    public removeLookups(): void {
        this.storageService.removeData(this.storageKey, sessionStorage);
    }
}
